import * as React from 'react';
import _ from 'lodash';
import * as Widget from 'segmentation-widget';
import { userTypeAppModeMap } from 'omega-rtc/utils/segp-utils';
import { Form } from 'semantic-grab-ui/src';
import { targetUserTypes } from 'data/trident-types';
import { getCombinedSegmentValue } from './constants/utils';
import './SegPWidget.scss';

interface SegPWidgetProps {
  targetUserType: string,
  onChange: Function, // string => void
  onSelect: Function, // string => void
  segmentVal: string, // it should be in the format of <namespace>.<segmentName> for non-dax, or just <segmentID> for dax
  maxVisible: number,
  enabledSegmentNSFormat: boolean,
  namespace?: string,
  showNsDropdown: boolean,
}

interface SegPWidgetInputState {
  defaultValue?: string;
}


// SegPWidget is a wrapper around SegPWidgetInput
// it encapsulates all the Trident logic for segment selection
export default class SegPWidget extends React.Component<SegPWidgetProps, SegPWidgetInputState> {
  constructor(props) {
    super(props);
    let defaultValue = props.segmentVal;
    if (!_.isEmpty(defaultValue)) {
      const splitted = _.split(defaultValue, '.', 2);
      if (splitted.length < 2) {
        // no namespace prefix, so it's considered in shared namespace
        defaultValue = `shared.${defaultValue}`;
      }
    }

    this.state = {
      defaultValue,
    };
  }

  render () {
    const { targetUserType, segmentVal, maxVisible, enabledSegmentNSFormat, namespace, showNsDropdown = true } = this.props;
    const appMode = userTypeAppModeMap[targetUserType];

    const { defaultValue } = this.state;

    return (<React.Fragment>
      {
        (targetUserType === targetUserTypes.dax || targetUserType === targetUserTypes.moveITDax) ?
          <Form.Input
            required
            value={segmentVal}
            onChange={(_, data) => this.props.onChange(data.value)}
          />
          :
          <div className="segp-widget">
            <Widget.SegPWidget
              src={`${window.Grab.config.SEGMENTATION_PLATFORM_URI}/widget`}
              onSelect={(segment) => {
                if (segment) {
                  const newSegmentVal = (targetUserType === targetUserTypes.pax || targetUserType === targetUserTypes.moveITPax || targetUserType === targetUserTypes.mex || targetUserType === targetUserTypes.ovo)
                    ? getCombinedSegmentValue(segment)
                    : segment.segmentName;
                  this.props.onChange(newSegmentVal);
                  if (this.props.onSelect) {
                    this.props.onSelect(newSegmentVal);
                  }
                }
              }}
              appMode={appMode}
              namespace={namespace}
              defaultValue={defaultValue}
              onInputChange={this.props.onChange}
              maxVisible={maxVisible}
              enabledSegmentNSFormat
              shouldValidate
              showNsDropdown={showNsDropdown}
            />
          </div>
      }
    </React.Fragment>);
  }
}
